import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface UserStore {
  picture: string;
  clientName: string;
  cnpj: string;
  profile: string[];
  email: string;
  idToken: string;
  clientId?: string;
  setUserData: (data: {
    picture: string;
    clientName: string;
    cnpj: string;
    profile: any;
    email: string;
    idToken: string;
  }) => void;
  setClientId: (clientId: string) => void;
  clearUserData: () => void;
}

export const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      picture: "",
      clientName: "",
      cnpj: "",
      profile: [],
      email: "",
      idToken: "",
      clientId: "",
      setUserData: ({ picture, clientName, cnpj, profile, email, idToken }) =>
        set({
          picture,
          clientName,
          cnpj,
          profile,
          email,
          idToken,
        }),
      setClientId: (clientId) =>
        set({
          clientId,
        }),
      clearUserData: () => {
        set({
          picture: "",
          clientName: "",
          cnpj: "",
          profile: [],
          email: "",
          idToken: "",
          clientId: "",
        });
        localStorage.removeItem("user-storage");
      },
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        picture: state.picture,
        clientName: state.clientName,
        cnpj: state.cnpj,
        profile: state.profile,
        email: state.email,
        idToken: state.idToken,
        clientId: state.clientId,
      }),
    }
  )
);
